(() => {
  const FORM_SELECTOR = '[data-form-root="true"]';
  const SUCCESS_STEP = 'success';
  const CUSTOM_EVENT_NAME = 'growhauzz_shopify_form_lead';
  const observedRoots = new WeakSet();
  const publishedForms = new WeakSet();

  function isSuccessfulForm(element) {
    return (
      element instanceof Element &&
      element.matches(FORM_SELECTOR) &&
      element.getAttribute('data-current-step') === SUCCESS_STEP
    );
  }

  function publishLead(form) {
    if (publishedForms.has(form)) return;

    const publish = window.Shopify?.analytics?.publish;
    if (typeof publish !== 'function') return;

    publishedForms.add(form);

    publish(CUSTOM_EVENT_NAME, {
      source: 'shopify_forms',
      formId: form.id || null,
      pagePath: window.location.pathname,
    });
  }

  function inspectAddedNode(node) {
    if (!(node instanceof Element)) return;

    discoverShadowRoots(node);

    if (isSuccessfulForm(node)) {
      publishLead(node);
    }

    node.querySelectorAll(FORM_SELECTOR).forEach((form) => {
      if (isSuccessfulForm(form)) publishLead(form);
    });
  }

  function handleMutations(mutations) {
    mutations.forEach((mutation) => {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'data-current-step'
      ) {
        const form = mutation.target;

        if (isSuccessfulForm(form)) {
          publishLead(form);
        } else if (form instanceof Element && form.matches(FORM_SELECTOR)) {
          publishedForms.delete(form);
        }
      }

      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(inspectAddedNode);
      }
    });
  }

  function observeRoot(root) {
    if (observedRoots.has(root)) return;

    observedRoots.add(root);

    new MutationObserver(handleMutations).observe(root, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['data-current-step'],
    });

    discoverShadowRoots(root);
  }

  function discoverShadowRoots(root) {
    const elements = [];

    if (root instanceof Element) elements.push(root);
    elements.push(...root.querySelectorAll('*'));

    elements.forEach((element) => {
      if (element.shadowRoot) observeRoot(element.shadowRoot);
    });
  }

  observeRoot(document);

  // Shopify Forms is injected asynchronously inside an open shadow root.
  window.setInterval(() => discoverShadowRoots(document), 1000);
})();
